import { render } from "./InlineEditor.vue?vue&type=template&id=dc0fa99a&scoped=true"
import script from "./InlineEditor.vue?vue&type=script&lang=js"
export * from "./InlineEditor.vue?vue&type=script&lang=js"

import "./InlineEditor.vue?vue&type=style&index=0&id=dc0fa99a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc0fa99a"]])

export default __exports__